import DOMPurify from 'dompurify';

/**
 * Sanitize HTML from API/CMS before dangerouslySetInnerHTML.
 * Server-side sanitization (Laravel) remains the primary control.
 */
export function sanitizeHtml(dirty) {
  if (!dirty || typeof dirty !== 'string') {
    return '';
  }

  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
  });
}
